import config from "../config";

export const getWeatherMapVariables = () => {
  // Assemble a list of all weather variables from the config file
  let allWeatherVariables: { modelID: string; variableID: string }[] = [];

  for (let key in config.weatherMapVariables) {
    const v =
      config.weatherMapVariables[
        key as keyof typeof config.weatherMapVariables
      ];
    if (v.type === "magnitude-direction") {
      allWeatherVariables.push({
        modelID: v.modelID,
        variableID: v.magnitudeVariableID,
      });
      allWeatherVariables.push({
        modelID: v.modelID,
        variableID: v.directionVariableID,
      });
    }
    if (v.type === "vector-components") {
      allWeatherVariables.push({
        modelID: v.modelID,
        variableID: v.eastingVariableID,
      });
      allWeatherVariables.push({
        modelID: v.modelID,
        variableID: v.northingVariableID,
      });
    }
    if (v.type === "scalar") {
      allWeatherVariables.push({
        modelID: v.modelID,
        variableID: v.variableID,
      });
    }
  }
  return allWeatherVariables;
};

export const getWeatherPlotVariables = () => {
  let allWeatherVariables: { modelID: string; variableID: string }[] = [];

  config.plotDropdownLabels.forEach((plot) => {
    plot.variables.forEach((v) => {
      allWeatherVariables.push({
        modelID: v.modelID,
        variableID: v.variableID,
      });
    });
  });

  return allWeatherVariables;
};
